/**
 * Set the document title for a page.
 *
 * `index.html` ships one static title — "Live Game Intelligence for Football
 * Coaching Staffs" — which every route inherits. That is wrong on the fan
 * pages: a parent who bookmarks or shares `/fans/join` should not see a title
 * selling a coaching subscription, and it is the text screen readers announce
 * on navigation.
 *
 * Restores the previous title on unmount so a route that does not set one is
 * never left showing another page's.
 */
import { useEffect } from 'react';

import { PRODUCT_NAME } from '../lib/constants';

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} — ${PRODUCT_NAME}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
